import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { PillarModule } from '../pillar/pillar.module'
import { CoreModule } from '../core/core.module';
import { FormsModule } from '@angular/forms';
import { extractsRoutes } from './routes.config';
import { reducers } from './store/reducers';
import { ModuleConfiguration } from './extracts.module.config';
import { ExtractsServiceEffects } from './services/ExtractsService.effects';
import { ExtractsService } from './services/ExtractsService';
import { ExtractsDashboardComponent } from './components/extracts-dashboard.component';
import { ExtractViewerComponent } from './components/extract-viewer.component';
import { CalOmsExtractWorkspaceComponent } from './components/caloms-extract-workspace.component';
import { ExtractFilterDialogComponent } from './components/extract-filter-dialog.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  entryComponents: [ExtractFilterDialogComponent],
  declarations: [ExtractsDashboardComponent, ExtractViewerComponent, CalOmsExtractWorkspaceComponent, ExtractFilterDialogComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule.forChild(extractsRoutes),
    StoreModule.forFeature(ModuleConfiguration.moduleName, reducers),
    EffectsModule.forFeature([ExtractsServiceEffects]),
    FormsModule,
    PillarModule,
    CoreModule,
    ReactiveFormsModule
  ],
  exports: [ExtractViewerComponent],
  providers: [ExtractsService]
})
export class ExtractsModule { }



// WEBPACK FOOTER //
// ./src/app/extracts/extracts.module.ts